const universalPrefix = '/2';
// const onUniversalPrefix = window.location.pathname.startsWith(universalPrefix)
// const forceUnprefixedOutputPatterns = [
// 	/^\/impressum\/?$/,
// 	/^\/agb\/?$/,
// 	/^\/logout\/?$/,
// 	/^\/en/,
// 	/^\/de/,
// 	/^\/login/,
// 	/^\/suche/,
// 	/^\/search/,
// 	/^\/psychotherapie/,
// 	/^\/profile/,
// 	/^\/appointment\/widget/,
// ]
export function stripUniversalPrefix(url) {
    if (url.pathname === universalPrefix) {
        url.pathname = '/';
        return url;
    }
    if (url.pathname.startsWith(`${universalPrefix}/`)) {
        url.pathname = url.pathname.slice(universalPrefix.length);
    }
    return url;
}
// function matchesAny(pathname: string, patterns: RegExp[]): boolean {
// 	return patterns.some(pattern => pattern.test(pathname))
// }
export function addLegacyPrefix(url) {
    // if (matchesAny(url.pathname, forceUnprefixedOutputPatterns)) {
    // 	return url
    // }
    // url.pathname = `${universalPrefix}${url.pathname === '/' ? '' : url.pathname}`
    return url;
}
//# sourceMappingURL=legacyPrefixRewrite.js.map